import { createContext } from 'react';
import { AccountAvailableCashParams } from '../type';

export const accountsAvailableCashParamsContext = createContext<Partial<AccountAvailableCashParams>>({});
